import { render } from "./CDCDevicesPage.vue?vue&type=template&id=2c494090&scoped=true"
import script from "./CDCDevicesPage.vue?vue&type=script&lang=js"
export * from "./CDCDevicesPage.vue?vue&type=script&lang=js"

import "./CDCDevicesPage.vue?vue&type=style&index=0&id=2c494090&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c494090"]])

export default __exports__